module.exports = __webpack_public_path__ + "static/media/structure2.df377983.png";